export const NAMESPACE = 'notificationCentre'
